import React, { useState } from 'react';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useLocation, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import InputFile from '@app/components/input-file/InputFile';
import { Get, Put } from '@app/utils/httpProvider';
import { useQuery, useQueryClient, useMutation } from 'react-query';
import {
    messageError,
    messageToast,
    status200,
} from '../../../utils/define';
import { BaseGatewayImage, TIMESLOTS_API } from '../../../utils/apiUrl';
import ReactSpinner from '../../../components/reactSpinner/ReactSpinner';


/**
 * @typedef {Object} TimeSlots
 * @property {string} time
 * @property {int} orderNumber
 * @property {boolean} isActive
 */

const schema = yup.object().shape({
    time: yup.string().required(messageError.emptyMessage),
});

const TimeSlotsEdit = () => {
    const history = useHistory();
    const queryClient = useQueryClient();
    const [isLoadingEdit, setIsLoadingEdit] = useState(false);
    const location = useLocation();
    const paramUrl = new URLSearchParams(location.search.substring(1));
    const id = paramUrl.get('id');

    const { isLoading, isError, error, data } = useQuery([id], () =>
        Get(TIMESLOTS_API.GET_BY_ID, id)
    );

    const editFunc = useMutation((value) =>
        Put(TIMESLOTS_API.UPDATE, value.id, value.data)
    );

    const handleEdit = async (values) => {
        const model = { ...values };
        const modelUpdate = {
            data: model,
            id: id
        };
        try {
            editFunc.mutate(modelUpdate, {
                onSuccess: (res) => {
                    if (res.status !== status200) {
                        toast.error(messageToast.messageToastUpdateError);
                    } else {
                        setIsLoadingEdit(true);
                        queryClient.setQueryData(id, model);
                        toast.success(messageToast.messageToastUpdateSuccess);
                        history.goBack();
                    }
                },
                onError: (res) => {
                    toast.error('Đã có lỗi xảy ra, vui lòng thử lại !');
                }
            });
        }
        catch (error) {
            toast.error("Có lỗi xảy ra khi xóa!");
        }

    };

    return (
        <Card>
            <Card.Header as="h5">Sửa khung giờ {data && data.time ? data.time : ''}</Card.Header>
            <Card.Body>
                {isLoading ? (
                    <div>Loading...</div>
                ) : isError ? (
                    <div>An error has occurred: ${error.message}</div>
                ) : data == null ? (
                    <div>Đối tác không tồn tại</div>
                ) : (
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(values) => handleEdit(values)}
                        initialValues={{
                            time: data && data.time ? data.time : '',
                            orderNumber:
                                data && data.orderNumber ? data.orderNumber : 0,
                            isActive:
                                data && data.isActive ? data.isActive : false
                        }}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values,
                            errors,
                            setFieldValue
                        }) => (
                            <Form noValidate onSubmit={handleSubmit}>

                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Khung giờ - hh:mm *
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control
                                            placeholder="Khung giờ hh:mm"
                                            type="text"
                                            name="time"
                                            value={values.time}
                                            onChange={handleChange}
                                            isInvalid={!!errors.time}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.time}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>

                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Trạng thái kích hoạt
                                    </Form.Label>
                                    <Col sm="10" className="icheck-primary">
                                        <Form.Control
                                            id="checkboxPrimary1"
                                            type="checkbox"
                                            placeholder="Trạng thái"
                                            name="isActive"
                                            checked={values.isActive}
                                            onClick={handleChange}
                                        />
                                        <Form.Label htmlFor="checkboxPrimary1">
                                            {' '}
                                        </Form.Label>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Thứ tự hiển thị
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control
                                            type="number"
                                            name="orderNumber"
                                            placeholder="Sắp xếp"
                                            value={values.orderNumber}
                                            onChange={handleChange}
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Col md={{ span: 10, offset: 2 }}>
                                        <ButtonGroup className="mb-2">
                                            <Button
                                                type="submit"
                                                theme="primary"
                                            >
                                                Sửa
                                            </Button>
                                            &nbsp;&nbsp;&nbsp;
                                            <Button
                                                onClick={() =>
                                                    history.goBack()
                                                }
                                                theme="secondary"
                                            >
                                                Hủy
                                            </Button>
                                        </ButtonGroup>
                                    </Col>
                                </Form.Group>
                            </Form>
                        )}
                    </Formik>
                )}
                <ReactSpinner loadings={isLoadingEdit} />
            </Card.Body>
        </Card>
    );
};

export default TimeSlotsEdit;
